export const environment = {
  staging: false,
  production: true,
  envName: 'prod',
};
